import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";
import { useImages } from "../context/ContentContext";
import { valuesData } from "../lib/data";

export default function Marque() {
  const { t, lang } = useLang();
  const IMG = useImages();
  const VALUES = valuesData(lang);
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 text-center mb-16">
        <Reveal>
          <p className="overline mb-4">{t("marque.overline")}</p>
          <h1 className="font-display text-5xl md:text-7xl mb-8" style={{ fontWeight: 300 }}>LUXE ORYVEA<br /><span className="rose-gold-text italic">Premium</span></h1>
          <p className="font-display text-2xl md:text-3xl leading-snug" style={{ fontWeight: 300 }}>
            {t("marque.quote")}
          </p>
        </Reveal>
      </div>

      <Reveal>
        <div className="max-w-6xl mx-auto px-6 md:px-12 mb-20">
          <img src={IMG.marque} alt="LUXE ORYVEA" loading="lazy" decoding="async" className="w-full h-[420px] md:h-[560px] object-cover" style={{ border: "1px solid var(--lo-border-rose)" }} />
        </div>
      </Reveal>

      <div className="max-w-3xl mx-auto px-6 space-y-6 mb-20 text-sm leading-relaxed" style={{ color: "var(--lo-muted)" }}>
        <Reveal><p>{t("marque.p1")}</p></Reveal>
        <Reveal delay={0.1}><p>{t("marque.p2")}</p></Reveal>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-3 gap-4 mb-16">
        {VALUES.map((v, i) => (
          <Reveal key={v} delay={i * 0.06}>
            <div className="card-lux p-8 text-center" data-testid={`value-${i}`}>
              <p className="font-display text-2xl" style={{ fontWeight: 400 }}>{v}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="text-center">
        <Link to="/serum" className="btn-primary inline-flex items-center h-14 px-10" data-testid="marque-cta">{t("common.discover_serum")}</Link>
      </div>
    </div>
  );
}
